import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  heading: {
    id: 'views.Partners.heading',
    defaultMessage: 'Partnerzy:'
  }
});



// WEBPACK FOOTER //
// ./src/views/Home/Sections/Partners/Partners.intl.js